/* eslint-disable @typescript-eslint/no-empty-function */
import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { BriefcaseIcon, HeartIcon, UserIcon, PencilSquareIcon, XMarkIcon } from '@heroicons/react/24/outline';
import tw, { styled, TwStyle } from 'twin.macro';

import { ButtonV2, IconButton, TabProp, Tabs, Title } from '@restworld/ui-ds';

import { MainUserInformation, WorkerSkillsAndLanguage } from './candidate-profile';
import { WorkerPreferences } from './candidate-profile/worker-preferences';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICandidateProfileSectionProps {}

const CandidateProfileSection: React.FunctionComponent<ICandidateProfileSectionProps> = (props) => {
  const tabs = useProfileTabs();
  return (
    <Tabs
      isSticky
      tabs={tabs}
      // tabPanelStyling={tw`md:(h-[calc(100vh - 395px)] overflow-y-scroll)`}
      tabListStyling={tw`lg:pt-4`}
    />
  );
};

export default CandidateProfileSection;

const useProfileTabs = () => {
  const { t } = useTranslation('onboarding-page');
  const tabs: TabProp[] = [
    {
      label: t('basic_information'),
      content: <MainUserInformation />,
      icon: <UserIcon tw="w-5 h-5" />,
    },
    {
      label: t('experiences'),
      content: <WorkerSkillsAndLanguage />,
      icon: <BriefcaseIcon tw="w-5 h-5" />,
    },
    {
      label: t('preferences'),
      content: <WorkerPreferences />,
      icon: <HeartIcon tw="w-5 h-5" />,
    },
  ];
  return tabs;
};

export const TabCardWrapper = ({
  children,
  title,
  onEdit,
  isEditMode,
  noBgColor,
}: {
  children: React.ReactNode;
  title?: string;
  onEdit?: () => void;
  isEditMode?: boolean;
  noBgColor?: boolean;
}) => {
  const { t } = useTranslation('common');

  return (
    <Card isEditMode={isEditMode} noBgColor={noBgColor} twStyle={tw`px-4 py-6 lg:(px-4 py-6)`}>
      <div tw="flex box-border flex-row items-center justify-between w-full p-0">
        <Title fontSize="extraLarge" fontWeight="semibold" twStyle={tw`leading-7.5`}>
          {title}
        </Title>
        {onEdit &&
          (isEditMode ? (
            <IconButton ariaLabel={t('close')} Icon={XMarkIcon} size="sm" onClick={onEdit} variant="restworld" />
          ) : (
            <ButtonV2 size="sm" variant="secondary-restworld" StartIcon={PencilSquareIcon} onClick={onEdit}>
              {t('edit')}
            </ButtonV2>
          ))}
      </div>
      {children}
    </Card>
  );
};
export const Card = styled.div<{ isEditMode?: boolean; noBgColor?: boolean; twStyle?: TwStyle }>`
  ${tw`flex box-border flex-col w-full rounded-3.75 lg:p-8 p-4  `}
  ${({ isEditMode }) => (isEditMode ? tw`` : tw`overflow-hidden`)};
  ${({ noBgColor }) => (noBgColor ? tw`border border-neutral-40 rounded-2xl p-4 lg:py-5 px-4` : tw` bg-primary-50`)};
  ${({ twStyle }) => twStyle || tw``}
`;
